import React, { useContext, useEffect, useState } from "react";
import Form from "../../components/form";
import {
  formatDateTime,
  isoToSqlDate,
  mergeParams,
} from "../../helpers/helpers";
import AppContext from "../../pages/app/context";
import api from "../../services/api";
import pedidoSituacao from "../../enums/pedidoSituacao";
import MUIDataTable from "mui-datatables";

let totais = {
  pedidos: "0",
  valor: "0",
};

export default function RelatorioPedidosPeriodo({ history, location }) {
  const { notification } = useContext(AppContext);
  const [registros, setRegistros] = useState([]);
  const [tabela, setTabela] = useState(false);

  const [dadosFiltros, setDadosFiltros] = useState(
    mergeParams(
      {
        dataInicial: `${new Date().getFullYear()}-${(new Date().getMonth() + 1)
          .toString()
          .padStart(2, "0")}-01`,
        dataFinal: isoToSqlDate(new Date().toISOString()),
      },
      location
    )
  );

  useEffect(() => {
    if (dadosFiltros.dataInicial && dadosFiltros.dataFinal) {
      carregarRelatorio();
    }
  }, []);

  const carregarRelatorio = (filtrosEnviar = dadosFiltros) => {
    setDadosFiltros(filtrosEnviar);
    api
      .get("relatorios/pedidosPeriodo", filtrosEnviar)
      .then((registros) => {
        let totalPedidos = 0;
        let totalValor = 0;

        registros.forEach((r) => {
          totalPedidos += 1;
          totalValor += r.pedidoValorTotal;

          r.pedidoDataHora = r.pedidoDataHora
            ? formatDateTime(r.pedidoDataHora, "D/M/Y h:m:s")
            : "-";
          r.pedidoSituacao = pedidoSituacao.desc(r.pedidoSituacao);
          r.pedidoValorTotal = (r.pedidoValorTotal / 100).toLocaleString(
            "pt-BR",
            {
              style: "currency",
              currency: "BRL",
            }
          );
        });
        totais = {
          pedidos: totalPedidos,
          valor: (totalValor / 100).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          }),
        };
        setRegistros(registros);
        setTabela(true);
      })
      .catch((err) => {
        notification("error", "Erro ao carregar o relatório");
      });
  };
  const filtros = {
    title: "Filtros",
    form: {
      dataInicial: {
        label: "Data inicial",
        type: "date",
        space: 6,
        value: dadosFiltros.dataInicial,
      },
      dataFinal: {
        label: "Data final",
        type: "date",
        space: 6,
        value: dadosFiltros.dataFinal,
      },
    },

    submit: {
      label: "Carregar",
      action: carregarRelatorio,
    },

    urlParams: true,
    history,
    location,
  };

  const fTotais = {
    title: "Totais",
    form: {
      pedidos: {
        label: "Pedidos",
        type: "text",
        space: 6,
        readOnly: true,
        value: totais.pedidos,
      },
      valor: {
        label: "Valor",
        type: "text",
        space: 6,
        readOnly: true,
        value: totais.valor,
      },
    },
  };

  return (
    <div>
      <Form formData={filtros} />
      {registros.length > 0 && <Form formData={fTotais} />}
      <br />
      {tabela && (
        <MUIDataTable
          title={"Pedidos por Período"}
          data={registros}
          columns={columns}
          options={options}
        />
      )}
    </div>
  );
}

const columns = [
  {
    name: "pedidoId",
    label: "Código do pedido",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: "escolaNome",
    label: "Escola",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: "pedidoDataHora",
    label: "Data",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: "pedidoValorTotal",
    label: "Valor",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: "pedidoNumeroParcelas",
    label: "Parcelas",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: "pedidoSituacao",
    label: "Situação",
    options: {
      filter: false,
      sort: true,
    },
  },
];

const options = {
  filterType: "checkbox",
  selectableRows: "none",
  rowsPerPage: 50,
  downloadOptions: {
    filename: "pedidos_periodo.csv",
    separator: ";",
    filterOptions: {
      useDisplayedColumnsOnly: false,
      useDisplayedRowsOnly: true,
    },
  },
  onDownload: (buildHead, buildBody, columns, data) => {
    return "\uFEFF" + buildHead(columns) + buildBody(data);
  },
};
